import application from 'application/application';

import template from './processes.template.html';

import controller from './processes.controller';

application

	.config(['$stateProvider', $stateProvider => {

		$stateProvider

			.state('root.default.processes', {
				url: '/processos?paginaAtual&registrosPorPagina&processo',
				views: {
					'default@root.default': {
						templateUrl: template,
						controller: controller
					}
				},
				data: {
					documentTitle: 'Processos',
					displayName: 'Processos'
				}
			});

	}]);
